import posthogClient from "posthog-js";

import { getEnv } from "@/hooks/useEnv";
import type { UserProfile } from "@/supabase.types";

(() => {
  if (getEnv("VITE_POSTHOG_TOKEN") && getEnv("VITE_POSTHOG_API_HOST")) {
    posthogClient.init(getEnv("VITE_POSTHOG_TOKEN") ?? "", {
      api_host: getEnv("VITE_POSTHOG_API_HOST") ?? "",
      secure_cookie: true, // transport only over https
      capture_pageview: false, // we manually capture pageviews via <AnalyticsRouterTracker />
    });
  }
})();

export const posthog = posthogClient;

export const setPosthogUser = (profile?: UserProfile | null) => {
  if (profile && !posthog._isIdentified()) {
    posthog.identify(profile.id, {
      ...profile,
    });
    if (getEnv("VITE_RELEASE_TAG")) {
      posthog.register({ release: getEnv("VITE_RELEASE_TAG") });
    }
  }
};
export const clearPosthogUser = () => posthog.reset();

export const trackPosthogEvent = (action: string, entity: string, properties?: Record<string, unknown>) => {
  posthog.capture(`${action} ${entity}`, {
    action,
    entity,
    ...properties,
  });
};
